import { Dispatch, SetStateAction } from "react";
import TextField from "@mui/material/TextField";
import CloseIcon from "@mui/icons-material/Close";
import {
  Modal,
  Button,
  FormControlLabel,
  Radio,
  RadioGroup,
} from "@mui/material";

interface AddCategoryModalProps {
  open: boolean;
  onClose: () => void;
  setOpen: Dispatch<SetStateAction<boolean>>;
}
const radioOptions = [
  {
    value: "year",
    label: (
      <div className="purchase_sub_bx">
        <p className="price">
          <img src="/static/images/subscription_icon.svg" alt="icon" />{" "}
          <ins>AED 8,000/</ins>
          <sub>Per year</sub>
        </p>
        <p>Ideal for those seeking uninterrupted access.</p>
      </div>
    ),
  },
  {
    value: "quarter",
    label: (
      <div className="purchase_sub_bx">
        <p className="price">
          <img src="/static/images/subscription_icon.svg" alt="icon" />{" "}
          <ins>AED 4,500/</ins>
          <sub>Semi-annual</sub>
        </p>
        <p>A flexible option to access full membership benefits.</p>
      </div>
    ),
  },
];
export default function Membership({
  open,
  onClose,
  setOpen,
}: AddCategoryModalProps) {
  return (
    <Modal className="modal membership_modal" open={open} onClose={onClose}>
      <div className="modal-dialog">
        <div className="modal-body">
          <div className="modal_title text_center mb_30">
            <h2>Select Membership to Upgrade</h2>
            <div className="btn-close" onClick={() => setOpen(false)}>
              <CloseIcon />
            </div>
          </div>
          <div className=" plan_grid">
            
            <RadioGroup
              aria-labelledby="demo-radio-buttons-group-label"
              defaultValue="year"
              name="radio-buttons-group"
              className="v2 mt_20"
            >
              {radioOptions.map((option) => (
                <FormControlLabel
                  key={option.value}
                  value={option.value}
                  control={<Radio />}
                  label={option.label}
                />
              ))}
            </RadioGroup>
          </div>
          <div className="mt_30">
            <Button className="btn btn_primary">Send Request</Button>
          </div>
        </div>
      </div>
    </Modal>
  );
}
